export default __webpack_public_path__ + "static/media/img-children.1537b070.jpg";